import React from "react";
import { ManaContent } from "../components/ManaContent/ManaContent";
import { Page } from "../components/Page/Page";
import "./PageLayout.css";

export function ManaPage() {
  return (
    <Page>
      <div className="page-layout page-layout--animated">
        <div className="page-content">
          <ManaContent />
        </div>
      </div>
    </Page>
  );
}
